<template>
  <div>
    <div v-if="!store.contact">
      <div class="deck deck--grey pa-1">
        {{ t('MessageNoContact') }}
      </div>
    </div>
    <div v-if="store.contact" class="deck deck-bg-white">
      <section class="section-right">
        <h2 class="headline-3" v-html="store.contact.form.title"></h2>
        <p class="contact-info-content">
          {{ t('ContactInfoInfoBoxContentHtml') }}
        </p>
        <p>&nbsp;</p>
        <ul>
          <li v-for="(selectedInsurance, key) in selectedInsurances" :key="key">
            {{ selectedInsurance.insurance }}
            <ul v-if="selectedInsurance.subInsurance ">
              <li v-for="(selectedSubInsurances, key) in selectedInsurance.subInsurance" :key="key">
                {{ selectedSubInsurances }}
              </li>
            </ul>
          </li>
          <li v-if="this.store.checkExtraInsurance">{{ this.store.otherInsurances }}</li>
        </ul>
        <p>&nbsp;</p>
        <div class="form">
          <div
            v-for="field in store.contact.form.fields"
            :key="field.name"
          >
            <div
              v-if="field.type=='checkbox'"
              class="form__field form__field--checkbox"
            >
              <div v-if="field.field_prefix" v-html="field.field_prefix"></div>
              <input
                :id="'field-'+field.name"
                v-model="field.value"
                :class="field.class"
                :type="field.type"
                class="form__item">
              <label
                :for="'field-'+field.name"
                class="form__label"
              >
                <span class="form__label__text">{{ field.label }}</span>
                <div v-if="field.field_suffix" class="contact-info-content" v-html="field.field_suffix"></div>
              </label>
            </div>
            <div
              v-else-if="field.type=='radio'"
              class="form__field form__field--radio"
            >
              <div v-if="field.field_prefix">
                <span v-html="field.field_prefix"></span>
                <span v-if="field.required === 'yes'" class="required">&nbsp;*</span>
              </div>
              <input
                :id="'field-'+field.id"
                :class="field.class"
                :name="field.name"
                :type="field.type"
                :value="field.label"
                class="form__item">
              <label
                :for="'field-'+field.name"
                class="form__label"
              >
                <span class="form__label__text">{{ field.label }}</span>
                <div v-if="field.field_suffix" class="contact-info-content" v-html="field.field_suffix"></div>
              </label>
            </div>
            <div
              v-else-if="field.type=='textarea'"
              class="form__field form__field--textarea"
            >
              <div v-if="field.field_prefix" v-html="field.field_prefix"></div>
              <label
                :for="'field-'+field.name"
                class="form__label"
              >
                <span class="form__label__text">{{ field.label }}</span>
                <span v-if="field.required === 'yes'" class="required">&nbsp;*</span>
              </label>
              <textarea
                :id="'field-'+field.name"
                v-model="message"
                v-model.trim="field.value"
                :class="field.class"
                :type="field.type"
                class="form__item"
                :maxlength="maxCharCount"
                v-on:keyup="countdown()"
              ></textarea>
              <p class='f--right form__label__text t--small'>
                {{ remainingCount }} / {{ maxCharCount }}
              </p>
              <div class="f--clear">
                <div v-show="errors.length && errors.includes(field.error_msg)" class="form_error">{{ field.error_msg }}
                </div>
                <div v-if="field.field_suffix" class="contact-info-content" v-html="field.field_suffix"></div>
              </div>
            </div>
            <div
              v-else
              :class="['form__field--'+field.type]"
              class="form__field"
            >
              <div v-if="field.field_prefix" v-html="field.field_prefix"></div>
              <label
                :for="'field-'+field.name"
                class="form__label"
              >
                <span class="form__label__text">{{ field.label }}</span>
                <span v-if="field.required === 'yes'" class="required">&nbsp;*</span>
              </label>
              <input
                :id="'field-'+field.name"
                v-model.trim="field.value"
                :class="field.class"
                :placeholder="field.placeholder"
                :type="field.type"
                class="form__item"
                @blur="field.name === 'email' ? field.value = removeSpace(field.value) : null">
              <div v-show="errors.length && errors.includes(field.error_msg)" class="form_error">{{ field.error_msg }}
              </div>
              <div v-if="field.field_suffix" class="contact-info-content" v-html="field.field_suffix"></div>
            </div>
          </div>
        </div>
        <div v-if="store.contact.buttons" class="form__field">
          <div v-if="store.contact.buttons[0].field_prefix" v-html="store.contact.buttons[0].field_prefix"></div>
          <button
            :class="[store.contact.buttons[0].class, {'is-loading': isLoading, 'is-disabled': !isValid && requestSent}]"
            :data-tealium="store.contact.buttons[0]['data-tealium']"
            :disabled="!isValid"
            class="button button--primary"
            @click="doSubmit">
        <span>
          {{ store.contact.buttons[0].label }}
        </span>
          </button>
        </div>
      </section>
    </div>
    <modal :active="showModal" @close="showModal = false">
      <slot>{{ modelContent }}</slot>
    </modal>
  </div>
</template>

<script>
import t from './../../../mixins/t.js'
import Modal from '@/components/common/Modal'
import Icon from '@/components/common/Icon'

export default {
  name: 'ContactInfo',
  components: {
    Icon,
    Modal
  },
  data () {
    return {
      store: this.$parent.store,
      isLoading: false,
      dataValid: true,
      requestSent: true,
      value: '',
      name: '',
      modelContent: '',
      errors: [],
      fields: this.$parent.store.contact.form.fields,
      showModal: false,
      showModelContR1: false,
      showModelContR2: false,
      inputCharCount: 0,
      message: '',
      hasError: false,
      maxCharCount: 255,
      remainingCount: 255
    }
  },
  mixins: [t],
  computed: {
    selectedInsurances: function () {
      let values = this.transformPostForm(
        this.store.insurances,
        this.store.optionalInsurances)
      return values
    },
    'isValid' () {
      return !this.store.contact.form.fields.some(field => {
        return field.value === '' && field.required === 'yes'
      })
    }
  },
  created () {
    let appCommercialGuide = document.getElementById('appCommercialGuide')
    if (appCommercialGuide) {
      appCommercialGuide.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'start'})
    }
    if (!this.store.insurances) {
      this.$router.push({name: 'Questions', params: {cvr: this.store.cvr, step: String(0)}})
    } else if (!this.store.contact) {
      this.$router.push({name: 'Questions', params: {cvr: this.store.cvr, step: String(0)}})
    }
  },
  methods: {
    removeSpace: function (value) {
      if (/\s/g.test(value)) {
        return value.replace(/\s/g, '')
      } else {
        return value
      }
    },
    validateData: function (value, name) {
      if (name === 'name') {
        var namere = /^(?!\s*$).+/
        if (namere.test(value) && value.length <= 100) {
          return true
        } else {
          return false
        }
      }
      if (name === 'email') {
        var emailre = /(.+)@(.+){1,}\.(.+){2,}/
        if (emailre.test(value) && value.length <= 200) {
          return true
        } else {
          return false
        }
      }
      if (name === 'phone') {
        var phonere = /^((?!(0))[0-9]{8})$/
        if (phonere.test(value) && value !== '12345678') {
          return true
        } else {
          return false
        }
      }
    },
    validate: function () {
      this.dataValid = true
      this.errors = []
      for (let i = 0; i < this.fields.length; i++) {
        if (this.validateData(this.fields[i].value, this.fields[i].name) === false) {
          this.errors.push(this.fields[i].error_msg)
          this.dataValid = false
        }
      }
    },
    doSubmit () {
      if (this.requestSent) {
        this.validate()
        if (this.dataValid) {
          this.isLoading = true
          this.requestSent = false
          this.$bus.$emit('app_submitForm')
        }
      }
    },
    transformPostForm (insurances, optionalInsurances) {
      let data = this.transformInsurances([...insurances, ...optionalInsurances], true)
      return data
    },
    transformInsurances (insurances, value) {
      let chosenInsurances = insurances.filter(insurance => {
        return insurance.selected === value
      })
      let values = chosenInsurances.map(insurance => {
        if (insurance.subInsurances) {
          let subInsurances = insurance.subInsurances
          let val = {}
          val.subInsurance = []
          val.insurance = insurance.title
          for (let i = 0; i < subInsurances.length; i++) {
            val.subInsurance[i] = subInsurances[i].title
          }
          return val
        } else {
          return {insurance: insurance.title}
        }
      })
      return values
    },
    showModalWindow (infoTxt) {
      this.modelContent = infoTxt
      this.showModal = true
    },
    countdown () {
      this.remainingCount = this.maxCharCount - this.message.length
      if (this.remainingCount <= 0) {
        this.message = this.message.substring(0, this.maxCharCount)
        this.remainingCount = 0
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media only screen and (max-width: 768px) {
  /* Use the whole width for form input in mobile view */
  .grid__col.grid__col--8 {
    flex: 100%;
  }
}

.svg-icon.info {
  width: 1.25rem;
  height: 2.25rem;
}

ol, ul {
  list-style: inside;
}

/deep/ h6 {
  font-weight: bold;
}

.form_error {
  color: #d63200;
}

.input_error {
  border: 0.063rem solid #d63200;
}

.required {
  color: red;
}

input:focus::placeholder {
  color: transparent;
  display: none
}
</style>



// WEBPACK FOOTER //
// src/components/pages/insuranceContact/ContactForm.vue